// extracted by mini-css-extract-plugin
export default {"mainWrapper":"MainPage_mainWrapper__pntfI","contentWrapper":"MainPage_contentWrapper__bq1qK"};